





















import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import {
  UserOldNameTable,
  UserOldNameTableItem
} from '@/components/organisms/UserOldNameTable'
import {
  UserOldAddressTable,
  UserOldAddressTableItem
} from '@/components/organisms/UserOldAddressTable'
import { UserDetailStateInfo } from '@/types'

export interface UserContentOldNameItem {
  oldNames: UserOldNameTableItem[]
  oldAddresses: UserOldAddressTableItem[]
}

export const defaultUserContentOldNameItem = (): UserContentOldNameItem => ({
  oldNames: [],
  oldAddresses: []
})

@Component({
  components: {
    InputCode,
    UserOldNameTable,
    UserOldAddressTable
  }
})
export default class UserContentOldName extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserContentOldNameItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number
}
